import React, { Component } from 'react';
import { connect } from 'react-redux';
import { 
  Modal, 
  Form, 
  FormGroup, 
  ControlLabel, 
  FormControl, 
  Row, 
  Col, 
  Button, 
  Table, 
  Grid 
} from 'react-bootstrap';
import { 
  format, 
  formatPercent, 
  numFormat, 
  formatDateYYYYMMDD
} from '../../containers/Dashboard/Helpers';
import { generatePrintout } from '../../actions';
import './ClientPrintout.css';

const sectors = {
  XLY: { sector: 'Discretionary' },
  XLP: { sector: 'Staples' },
  XLE: { sector: 'Energy' },
  XLF: { sector: 'Financials' },
  XLRE: { sector: 'Reits' },
  XLV: { sector: 'Healthcare' },
  XLI: { sector: 'Industrials' },
  XLK: { sector: 'Technology' },
  XLB: { sector: 'Materials' },
  XLU: { sector: 'Utilities' },
  XLC: { sector: 'Communication Services' },
}

class ClientPrintoutModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      printoutInfo: {},
      printoutSectorInfo: {},
      portfolioTotal: 0,
      accountHolder: '',
      accountNumber: ''
    };
  }

  onCloseModal = () => {
    this.setState({ 
      printoutInfo: {}, 
      printoutSectorInfo: {}, 
      portfolioTotal: 0, 
      accountHolder: '',
      accountNumber: ''
    });
    this.props.closeModal('showClientPrintoutModal');
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      this.setUp(this.parseCSV(reader.result));
    };
    reader.readAsText(file);
  };

  parseCSV = (fileContent) => {
    const jsonAr = [];
    const splitCSV = fileContent.split('\n');

    for (let i = 0; i < splitCSV.length; i++) {
      const splitLine = splitCSV[i]
        .split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
        .map(item => {
          return item.replace(/,/g, '').replace(/"/g, '');
        });

      if (splitLine[2] && splitLine[9]) {
        if (splitLine[2].trim() === 'Buy' && splitLine[9].trim() === 'Equity') {
          jsonAr.push({
            actionType: splitLine[2],
            symbol: splitLine[3],
            shares: +splitLine[4],
            purchasePrice: +(splitLine[6].replace(/\$|,/g, '')),
            type: splitLine[9]
          });        
        }
      }
    }
    return jsonAr;
  };

  setUp = (fileContent) => {
    const { tickerInfo, sectorInfo } = this.props.user;
    const printoutInfo = {}, printoutSectorInfo = {};

    for (let i = 0; i < fileContent.length; i++) {
      const { symbol } = fileContent[i];
      const findTicker = tickerInfo.filter(ticker => ticker.symbol === symbol)[0];

      if (!findTicker) continue;

      if (!printoutInfo[symbol]) {
        printoutInfo[symbol] = fileContent[i];
      } else {
        const totalShares = printoutInfo[symbol].shares + fileContent[i].shares;
        const avgPrice = printoutInfo[symbol].shares / totalShares * printoutInfo[symbol].purchasePrice +
          fileContent[i].shares / totalShares * fileContent[i].purchasePrice;

        printoutInfo[symbol].purchasePrice = avgPrice;
        printoutInfo[symbol].shares = totalShares;
      }

      printoutInfo[symbol].sectorSymbol = findTicker.sectorSymbol;
      printoutInfo[symbol].name = findTicker.name;
    }

    let portfolioTotal = 0;
    for (const item in printoutInfo) {  
      const stockValue = printoutInfo[item].purchasePrice * printoutInfo[item].shares; 
      printoutInfo[item].stockValue = stockValue
      portfolioTotal += stockValue;
    }

    for (const item in printoutInfo) {
      printoutInfo[item].stockWeight = (printoutInfo[item].stockValue / portfolioTotal) * 100;
    }

    for (const item in sectorInfo) {
      const symbol = sectorInfo[item].symbol;
      
      let sectorWeight = 0;
      for (const ticker in printoutInfo) {
        if (printoutInfo[ticker].sectorSymbol === symbol) {
          sectorWeight += printoutInfo[ticker].stockWeight;
        }
      }

      printoutSectorInfo[symbol] = {
        symbol: symbol,
        name: sectors[symbol].sector,
        sectorWeightSG: sectorWeight,
        sectorWeightSNP: +sectorInfo[item].sectorWeight,
        sectorWeightDiff: sectorWeight - +sectorInfo[item].sectorWeight
      }
    }

    this.setState({ 
      printoutInfo: printoutInfo,
      printoutSectorInfo: printoutSectorInfo,
      portfolioTotal: portfolioTotal
    }, () => {
      this.createPrintout();
      this.onCloseModal();
    });
  };

  createPrintout = () => {
    const htmlBody = document.getElementById('printout-container').innerHTML;
    this.props.generatePrintout({
      htmlBody: htmlBody,
      type: 'client'
    });
  }
 
  printoutRows = () => {
    const { printoutInfo, printoutSectorInfo } = this.state;
    let theme = 'odd-row';

    return Object.keys(sectors).map((sectorKey, index) => {
      const ar = [];
      for (const item in printoutInfo) {
        if (sectorKey === printoutInfo[item].sectorSymbol) {
          ar.push(printoutInfo[item]);
        }
      }

      if (ar.length) {
        if (theme === 'even-row') theme = 'odd-row';
          else theme = 'even-row';
      }

      return ar.map((item, index) => {
        const { sectorSymbol } = item;
        const isSectorRow = index === 0 ? true : false;

        return (
          <tr key={item.symbol} className={`${(isSectorRow ? 'sector-row' : null)} ${theme}`}>
            <td>{item.symbol}</td>
            <td>{formatPercent(item.stockWeight)}</td>
            <td>{item.name}</td>
            <td>{item.shares}</td>
            <td>{format(item.purchasePrice)}</td>
            { isSectorRow ? <td>{printoutSectorInfo[sectorSymbol].name}</td> : <td></td>}
            { isSectorRow ? <td>{formatPercent(printoutSectorInfo[sectorSymbol].sectorWeightSG)}</td> : <td></td>}
            { isSectorRow ? <td>{formatPercent(printoutSectorInfo[sectorSymbol].sectorWeightDiff)}</td> : <td></td>}
            { isSectorRow ? <td>{formatPercent(printoutSectorInfo[sectorSymbol].sectorWeightSNP)}</td> : <td></td>}
          </tr>
        );
      });
    });
  }

  getCurrentDate = () => {
    return formatDateYYYYMMDD(new Date());
  }

  render() {
    const { accountHolder, accountNumber, portfolioTotal } = this.state;

    return (
      <Modal show={this.props.showClientPrintoutModal} onHide={this.onCloseModal} className="toolbar-modal">
        <Modal.Header closeButton>
          <Modal.Title>Client Printout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col mdOffset={2} md={8}>
              <Form>
                <FormGroup controlId="accountHolder">
                  <ControlLabel>Enter Account Name:</ControlLabel>
                  <FormControl 
                    type="text" 
                    placeholder="" 
                    value={this.state.accountHolder}
                    name="accountHolder" 
                    onChange={this.onInputChange} />
                </FormGroup>
                <FormGroup controlId="accountNumber">
                  <ControlLabel>Enter Account Number:</ControlLabel>
                  <FormControl 
                    type="text" 
                    placeholder="" 
                    value={this.state.accountNumber}
                    name="accountNumber" 
                    onChange={this.onInputChange} />
                </FormGroup>
                <label className="btn btn-primary btn-blue import-btn">
                  Import Shares &amp; Prices
                  <input
                    onChange={this.onFileChange}
                    type="file"
                    accept=".csv"
                    name="file"
                    style={{ display: 'none' }}
                  />
                </label>
              </Form>
            </Col>
          </Row>

          <div style={{ display: 'none' }} id="printout-container">
            <Grid fluid className="client-printout">

              <img className="logo" src={'https://www.scmportfolio.com/printout/sitrin-logo.png'} alt="Logo" />

              <div className="info">
                <div>
                  <strong>Date:</strong> {this.getCurrentDate()}
                </div>
                <p>
                  <strong>Total:</strong> ${numFormat(format(portfolioTotal))}
                </p>
              </div>

              <div className="info">
                <div>
                  <strong>Account Holder:</strong> {accountHolder}
                </div>
                <p>
                  <strong>Account:</strong> {accountNumber}
                </p>
              </div>

              <Table className="printout-table">
                <thead>
                  <tr>
                    <th colSpan="5" />
                    <th colSpan="4" className="sector-header">
                      SECTOR
                    </th>
                  </tr>
                  <tr>
                    <th>Ticker</th>
                    <th>Weight</th>
                    <th>Company</th>
                    <th>Shares</th>
                    <th>Entry Price</th>
                    <th>Sector</th>
                    <th className="sector-cols">SG</th>
                    <th className="sector-cols">vs S&amp;P</th>
                    <th className="sector-cols">S&amp;P</th>
                  </tr>
                </thead>
                <tbody>
                  {this.printoutRows()}
                </tbody>
              </Table>
            </Grid>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            bsStyle="default" 
            onClick={this.onCloseModal}
          >Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps({ user }) {
  return {
    user
  };
}

export default connect(mapStateToProps, { generatePrintout })(ClientPrintoutModal);
